export const CARDS = 'CARDS'
export const TABLE = 'TABLE'
